import { AxiosStorage } from './storage';
export class MemoryAxiosStorage extends AxiosStorage {
    constructor(storage = {}) {
        super();
        this.storage = storage;
        this.find = async (key) => {
            return this.storage[key] || { state: 'empty' };
        };
        this.set = async (key, value) => {
            this.storage[key] = value;
        };
        this.remove = async (key) => {
            delete this.storage[key];
        };
    }
}
